export const SettingsSectionHeader: React.FC<React.PropsWithChildren> = props => {
    const { children } = props;
    return <h4 tw="font-semibold uppercase mt-5 mb-3 text-builder-xs">{children}</h4>;
};

export const SettingsSectionDividerFullWidth: React.VFC = () => (
    <div tw="border-solid border-t border-border-pale my-5" />
);
export const SettingsSectionDivider: React.VFC = () => <div tw="border-solid border-t border-border-pale my-6 -mx-5" />;
